export const CHALLENGE = "FACIAL_BIOMETRICS"